import { Component, OnInit, } from '@angular/core';
import { AUTH_REASON, TRADE_SLIPPAGE } from 'src/app/angular-wallet-base/constants';
import { presentToast } from 'src/app/angular-wallet-base/utils';
import { PinModalComponent, } from 'src/app/components/pin-modal/pin-modal.component';
import { ModalController, NavController, NavParams, Platform, ToastController, } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { GetTradeOrdersAction, GetTradeOrdersHistoryAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { SuccessOrderComponent } from '../success-order/success-order.component';
import { TradeService } from 'src/app/angular-wallet-base/services/trade.service';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from 'src/app/angular-wallet-base/services/environment.service';

@Component({
  selector: 'app-review-order',
  templateUrl: './review-order.component.html',
  styleUrls: ['./review-order.component.scss']
})
export class ReviewOrderComponent implements OnInit {

  public reviewOrderDetails;
  public loader: boolean = false;
  public isDesktopMode: boolean;

  public payload;
  public assetToTrade;
  public tradeFor;

  private marketPayload: any;

  public tradeFeature = this.environmentService.trade;

  constructor(
    protected store: Store<AppState>,
    private appMode: AppModeService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private oneInchService: OneInchService,
    private translate: TranslateService,
    private toast: ToastController,
    private platform: Platform,
    private tradeService: TradeService,
    private environmentService: EnvironmentService
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
    this.payload = await this.navParams.get('payLoad');
    this.assetToTrade = await this.navParams.get('assetToTrade');
    this.tradeFor = await this.navParams.get('tradeFor');
    if (this.payload.orderType === 'market') {
      this.getEstimationForMarketOrder();
    }
  }

  async getEstimationForMarketOrder() {
    this.loader = true;
    try {
      const results = await this.tradeService.getPayloadForSwap(
        this.assetToTrade.address,
        this.assetToTrade.assetGuid,
        this.tradeFor.assetGuid,
        +this.payload.price,
        TRADE_SLIPPAGE,
      );
      Logger.info('Get estimation for market order', results);
      this.payload.size = Number(results.swapDetails.price);
      this.marketPayload = results.swapPayload;
    } catch (error) {
      if (error?.error != 2) {
        await presentToast('Warning', error?.message, this.translate, this.toast, this.platform, true);

      } // ignore allowance warning for now
      // Show warning, if payload not received
    }
    this.loader = false;
  }

  async onSubmit() {
    const modal =
     await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.PLACE_TRADE_ORDER
      },
      id: 'pinModal'
    });
    await modal.present();
    await modal.onDidDismiss().then(response => {
      if (response.data && response.data.pin) {
        this.placeOrder(response.data.pin);
      }
    });
  }

  async toSuccessOrderModal() {
    const cssClass = (this.isDesktopMode) ? 'confirm-modal-desktop' : 'confirm-modal';
    const modal = await this.modalCtrl.create({
      component: SuccessOrderComponent,
      backdropDismiss: false,
      cssClass,
      id: 'successOrderModal'
    });
    await modal.present();
    await modal.onDidDismiss().then(async response => {
      if (response.data && response.data.toHome) {
        this.goBack('toHome');
      } else {
        this.goBack('resetForm');
      }
    });
  }

  async placeOrder(pin: string) {
    this.loader = true;
    try {
      switch (this.payload.orderType) {

        case 'market':
          const userWallet = await this.oneInchService.getWallet(pin);
          Logger.info('Current wallet address', userWallet.address);

          // check allowance
          const currentAllowance = await this.tradeService.checkAllowance(
            userWallet.address,
            this.assetToTrade.assetGuid,
            this.tradeFor.assetGuid
          );
          if (
            !currentAllowance ||
            parseFloat(currentAllowance) === 0 ||
            parseFloat(currentAllowance) <= this.payload.price
          ) {
            // approval allowance with max
            await this.tradeService.approveTheMaxAllowanceForRouter(this.assetToTrade.assetGuid, this.tradeFor.assetGuid, userWallet);

            // update transaction data again
            await this.getEstimationForMarketOrder();
          }

          const marketOrderResult = await this.tradeService.swapOrderMarketPlace(
            this.assetToTrade.assetGuid,
            this.tradeFor.assetGuid,
            userWallet,
            this.marketPayload
          );
          if (marketOrderResult && marketOrderResult.transactionHash) {
            Logger.info('place order', marketOrderResult);

            await presentToast(
              'review_order.success',
              this.tradeFeature ? 'review_order.success_message' : 'swap_review_order.success_message',
              this.translate,
              this.toast,
              this.platform
            );
            this.marketPayload = null;
            this.goBack('resetForm');
          }
          if (marketOrderResult && marketOrderResult.error) {
            Logger.info('place order error', marketOrderResult.error);

            if (marketOrderResult.error === 2) {
              Logger.info('place order error', marketOrderResult?.message);
              await presentToast('review_order.failed', 'review_order.failed_approve_message', this.translate, this.toast, this.platform);
            } else {
              await presentToast('review_order.failed', 'review_order.failed_message', this.translate, this.toast, this.platform);
            }
            this.goBack();
          }
          break;

        case 'limit':
          const limitOrderResult = await this.oneInchService.placeOrder(
            pin,
            this.assetToTrade.assetGuid,
            this.payload.price,
            this.tradeFor.assetGuid,
            this.payload.size,
            this.payload.expiry
          );
          if (limitOrderResult.success) {
            this.marketPayload = null;
            await this.toSuccessOrderModal();
          } else {
            await presentToast('review_order.failed', 'review_order.failed_message', this.translate, this.toast, this.platform);
            this.goBack();
          }

          // get open orders
          this.store.dispatch(new GetTradeOrdersAction(true));
          this.store.dispatch(new GetTradeOrdersHistoryAction(true));
          break;
      }
    } catch (error) {
      Logger.info('place order', error);

      await presentToast('review_order.failed', 'review_order.failed_message', this.translate, this.toast, this.platform);
      this.goBack();
    }
  }

  goBack(returnData = null) {
    this.modalCtrl.dismiss(returnData);
  }

}
